import { localContentPrefix } from '../../../../config';
import { http } from '../../../axios';
import { Pagination } from '../../../../../models/Pagination';
import { MarketplaceProductsResponse } from '../../../../store/apiLibx';
import { AgeCategory } from '../../../../../models/AgeCategory';

export interface LocalRegionProductParams {
    pagination: Pagination;
    filterMap: string;
    region?: string;
    ageCategory?: string | null;
    shopLanguage: string | undefined;
}

export const fetchLocalRegionsProducts = ({
    pagination,
    filterMap,
    region,
    ageCategory,
    shopLanguage
}: LocalRegionProductParams) => {
    const { page, pageSize, sortBy } = pagination;

    return http
        .post<MarketplaceProductsResponse>(
            `${localContentPrefix}/v1/marketplace/localregions/:region/products`,
            filterMap,
            {
                pathParams: { region },
                params: {
                    page,
                    pageSize,
                    sortBy,
                    ageCategory: ageCategory === AgeCategory.ALL_AGES ? null : ageCategory,
                    shopLanguage
                }
            }
        )
        .then(response => response.data);
};
